import {Link} from "react-router-dom";
import {mapRoutesEnToSv} from "../Utils/routes";
import BackButton from "./BackButton";

function Breadcrumbs({links, background}: any) {
    const length = links.length - 2;

    const breadcrumbs: any = [];
    links.forEach((link: any, index: number) => {
        if (index === 0 || index >= links.length - 2) {
            breadcrumbs.push(link);
        } else if (index === links.length - 3) {
            breadcrumbs.push({
                ...link,
                title: '...'
            })
        }
    })

    return (
        <div className={`${background}`}>
            <div className="fixed left-4 bottom-4 z-20 xl:hidden">
                <BackButton />
            </div>
            <div className={`container flex flex-wrap gap-1 max-w-3xl py-8 font-body text-base text-grey-900`}>
                {breadcrumbs && breadcrumbs.map((linkItem: any, index: number) => {
                    return <span key={index} className="max-w-[100%]">
                        {linkItem.link.length
                            ? <span className={`whitespace-nowrap flex flex-nowrap gap-1`}>
                                <Link className="underline decoration-1 underline-offset-2 hover:no-underline text-ellipsis overflow-hidden" to={mapRoutesEnToSv(linkItem.link)}>{linkItem.title}</Link> /
                              </span>
                            : <span className="text-grey-700">{linkItem.title}</span>
                        }
                    </span>;
                })}
            </div>
        </div>
    );
}

export default Breadcrumbs;